/**
 * @Description 普通进度条
 */

import { FC } from 'react';
import styles from '../entry.module.less';
import cs from 'classnames';

const NormalProgress:FC<{
  title: any,
  value: any,
  theme: 'blue' | 'red',
  className?: any
}> = ({
  title,
  value,
  theme = 'blue',
  className
}) => {
  return (
    <div className={cs(styles['progress'], className)}>
      <div className={styles['progress-title']}>{title}</div>

      <progress max={100} value={value} className={cs(styles['progress-content'], theme !== 'blue' ? styles['red'] : '')}/>

      <div className={styles['progress-value']}>{value + '%'}</div>
    </div>
  );
};

export default NormalProgress;
